<app-event-payment-schedule
  [currentTabname]="tabName"
  [selectedProgramOption]="selectedProgramOption"></app-event-payment-schedule>
